<script setup lang="ts">
  import NavigationListItem from '@internal/components/navigation-list/navigation-list-item.vue'
  import type { INavigationList } from '@internal/types/navigation-list'

  defineProps<{
    list: Array<INavigationList>
  }>()
  const emit = defineEmits(['change-route'])
</script>

<template>
  <ul class="tw-relative tw-p-0 xs:tw-py-6 md:tw-pb-6 md:tw-pt-0 tw-m-0 tw-list-none" role="menubar">
    <navigation-list-item
      v-for="(item, index) in list"
      :key="`nav-item_${index}`"
      :item="item"
      @click="emit('change-route')"
    />
  </ul>
</template>
